module.exports = __webpack_public_path__ + "public/img/broadcast.957e2754.png";